import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PageGuardPelaksanaanDate } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PageGuardPelaksanaanDate'
import { useNewDocumentFlow } from 'app/KinerjaShared/hooks/useNewDocumentFlow'
import { NotFoundError } from 'utils/customError'
import { PelaksanaanTugasPokok } from 'app/KinerjaPage/pages/PelaksanaanV2/TugasPokok/PelaksanaanTugasPokok'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaPelaksanaanEnabled =
      toggle?.['kinerja-pelaksanaan-enabled'] || false
    const isNewDocumentFlowEnabled =
      toggle?.['kinerja-new-document-flow-enabled'] || true

    if (
      !isKinerjaEnabled ||
      !isKinerjaPelaksanaanEnabled ||
      !isNewDocumentFlowEnabled
    ) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const TugasTambahan = () => {
  const { status } = useNewDocumentFlow()

  if (status !== 'NEW_DOCUMENT_FLOW') {
    throw new NotFoundError('', 'Not Found')
  }

  return (
    <KinerjaTipeProvider tipe="SPF">
      <PageGuardPelaksanaanDate>
        <PelaksanaanTugasPokok />
      </PageGuardPelaksanaanDate>
    </KinerjaTipeProvider>
  )
}

TugasTambahan.Layout = KinerjaLayout

TugasTambahan.layoutOpts = {
  hasHeader: true,
}

export default TugasTambahan
